"use client";

import React from "react";
import { CssBaseline, ThemeProvider } from "@bpipartners/webui";
import { getSCEVTheme } from "@cbex/utils/theme";

export const ScevClientProviders = ({ children }: { children?: any }) => (
  <ThemeProvider theme={getSCEVTheme()}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);
